export const LIST_QUERY = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];

export const REQUIRED_ID_NUMBER_FIELD = 'Vui lòng nhập số CCCD / Căn cước';

export const RTDM = {
  title: 'Duyệt vay trong 90s',
  rootPath: '/duyet-vay-trong-90s',
};

export const OFS = {
  FB: {
    title: 'Vay nhanh uy tín',
    registerPath: '/dang-ky',
    rootPath: '/vay-nhanh-uy-tin',
  },
  ZALO: {
    title: 'Vay trực tuyến',
    rootPath: '/vay-truc-tuyen',
  },
};

export const CLX_REGISTRATION = {
  title: 'Đăng ký',
  rootPath: '/dang-ky',
};

export const APP_LINK = 'https://hcv.onelink.me/ausQ/27';
export const BNPL_LINK =
  'https://homepaylater.vn/mp/dang-ky?partner=SAO&utm_source=clxlp';
export const GMA_LINK =
  'https://hcv.onelink.me/ausQ?pid=BrandMKT&c=Website&af_adset=tien-mat';
export const NEW_CLIENT_GMA_LINK = 'https://hcv.onelink.me/ausQ/101';
export const ACL_LINK =
  'https://vaytienmat.homecredit.vn/bat-dau-vay-moi?utm_source=CLXWeb ';
